/* eslint-disable no-unused-vars */
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import axios from 'axios';
import Cookies from 'universal-cookie';
import i18n from '../i18n';

const baseURL = 'https://menu.all-win100.com/dashbord/';
const cookies = new Cookies();

const axiosInstance = axios.create({
  baseURL,
});

export const axiosBaseQuery =
  () =>
  async ({ url, method, data, params, withToken, isFormData }, { signal }) => {
    try {
      const headers = {};

      // Get current language from i18n or localStorage, default to 'ar'
      const currentLang = i18n?.language || localStorage.getItem('i18nextLng') || 'ar';
      
      // Set Accept-Language header with both languages, current language first
      // This ensures the API returns both Arabic and English texts
      if (currentLang === 'ar') {
        headers['Accept-Language'] = 'ar,en';
      } else {
        headers['Accept-Language'] = 'en,ar';
      }

      if (withToken) {
        const token = cookies.get('authToken');
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }
      }

      if (!isFormData) {
        headers['Content-Type'] = 'application/json';
      }

      const response = await axiosInstance({
        url,
        method,
        data,
        params,
        headers,
        signal,
      });

      return { data: response.data };
    } catch (err) {
      if (err.code === 'ERR_CANCELED' || err.name === 'CanceledError') {
        return {
          error: {
            status: 'CANCELLED',
            data: 'Request was cancelled',
          },
        };
      }

      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };